import Modal from 'react-bootstrap/Modal';

const SuccessModal = (props) => {
  const {modalShow, handleOkClick, claimID} = props

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={modalShow}
      backdrop="static"
    >
      <Modal.Body>
            <div className="main-box text-center">
              <a className="center">
                <img src="/kshemaImages/Star.png" alt="Success" width="132px" height="132px" className="center" />
              </a>
              <p className="claim_success">Claim Filed Successfully</p>
              <p className="claim_description">We have successfully Filed your Claim,<br />
                This is Your Claim ID: <b>{claimID}</b></p>
              <div className="hover">
                <p className="submit-box center" onClick={() => { handleOkClick() }}>OK</p></div>
            </div>
      </Modal.Body>
    </Modal>
  )
}

export default SuccessModal